import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "SQL语句：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_json_viewer = _resolveComponent("json-viewer")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      model: _ctx.detail,
      "label-width": "80px",
      inline: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "消息",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSeeJson(_ctx.detail)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.Message), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatTime(_ctx.detail?.CreatedTime, "YYYY/MM/DD hh:mm:ss")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.detail?.Http)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "地址" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Http.Method) + " " + _toDisplayString(_ctx.detail.Http.Scheme) + "://" + _toDisplayString(_ctx.detail.Http.Host) + _toDisplayString(_ctx.detail.Http.Path), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "Id" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Http.RequestId), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (
          _ctx.detail.Http.RefererUrl || _ctx.detail.Http.Ip4 || _ctx.detail.Http.UserAgent
        )
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    gutter: 20
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "来源" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail.Http.RefererUrl) + " - " + _toDisplayString(_ctx.detail.Http.Ip4) + " - " + _toDisplayString(_ctx.detail.Http.UserAgent), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.detail.Http.CreatedUserId)
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 1,
                    gutter: 20
                  }, {
                    default: _withCtx(() => [
                      (_ctx.detail.Http.CreatedCompanyId)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "公司" }, {
                                default: _withCtx(() => [
                                  (_ctx.detail.Http.CreatedCompanyId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.detail.Http.CreatedCompanyNameZh) + "（" + _toDisplayString(_ctx.detail.Http.CreatedCompanyId) + "） ", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "用户" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail.Http.CreatedUserName) + "/" + _toDisplayString(_ctx.detail.Http.CreatedPhoneNumber) + "（" + _toDisplayString(_ctx.detail.Http.CreatedUserId) + "） ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  (_ctx.detail.Http.Param)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "参数" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, "内容类型：" + _toDisplayString(_ctx.detail.Http.ContentType), 1),
                              (_ctx.detail.Http.ContentLength)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " - 长度：" + _toDisplayString(_ctx.detail.Http.ContentLength), 1))
                                : _createCommentVNode("", true),
                              (_ctx.detail.Http.Param && _ctx.detail.Http.Param != '{}')
                                ? (_openBlock(), _createBlock(_component_json_viewer, {
                                    key: 1,
                                    value: JSON.parse(_ctx.detail.Http.Param)
                                  }, null, 8, ["value"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.detail.Http.Success != undefined)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "结果" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail.Http.Success == true
                ? "执行成功"
                : _ctx.detail.Http.Success == false
                ? "执行失败"
                : "暂无数据") + " ", 1),
                              (_ctx.detail.Http.Result && _ctx.detail.Http.Result != '{}')
                                ? (_openBlock(), _createBlock(_component_json_viewer, {
                                    key: 0,
                                    value: JSON.parse(_ctx.detail.Http.Result)
                                  }, null, 8, ["value"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "日志" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Http.Logs, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(_component_el_alert, {
                        title: 
              _ctx.formatTime(item.CreatedTime, 'ss.SSS') + ' - ' + item.Message
            ,
                        type: "info",
                        effect: "light",
                        onClick: ($event: any) => (_ctx.handleSeeJson(item))
                      }, null, 8, ["title", "onClick"])
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalJson,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalJson) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.log?.Sql)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("textarea", {
                ref: "codemirror",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.log.Sql.CommandText) = $event))
              }, " ", 512), [
                [_vModelText, _ctx.log.Sql.CommandText]
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_json_viewer, {
          value: JSON.parse(_ctx.log?.LogOriginalText ?? '{}')
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}